import React from "react";

const ContactUs = () => {
  return (
    <section className="contact-section" id="contact">
      <h2>Contact Us</h2>
      <div className="contact-info-wrapper">
        <div className="contact-item">
          <span role="img" aria-label="phone">📞</span>
          <div>
            <h3>Phone</h3>
            <p>
              <a href="tel:+919666696905" className="text-decoration-none">+91 96666 96905</a>
            </p>
          </div>
        </div>

        <div className="contact-item">
          <span role="img" aria-label="email">📧</span>
          <div>
            <h3>Email</h3>
            <p>
              <a href="mailto:info@sweetdelights.com">info@idealfoods.com</a>
            </p>
          </div>
        </div>

        <div className="contact-item">
          <span role="img" aria-label="address">📍</span>
          <div>
            <h3>Address</h3>
            <p>
              <a
                href="https://www.google.com/maps/place/Seven+Days+Bakery+-+Tadigadapa/@16.479056,80.699904,16z/data=!4m6!3m5!1s0x3a35fba51dc1e1df:0x979ea54b1a75cd!8m2!3d16.4789693!4d80.7001002!16s%2Fg%2F11gxnvsscg?hl=en&entry=ttu&g_ep=EgoyMDI1MDYwNC4wIKXMDSoASAFQAw%3D%3D"
                target="_blank"
                rel="noopener noreferrer"
              >
                Seven Days Cafe - Tadigadapa
            2-151, Tadigadapa - Penamaluru Rd, Tadigadapa, Poranki, Vijayawada, Andhra Pradesh 521134
              </a>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactUs;
